import React, { useState, useEffect } from "react";

// Ticket login (used to display the login form)
const TicketLogin = (props) => {
    const {
        config,
        authenticationToken,
        memberCredentials,
        setMemberCredentials,
        isMember,
        setIsMember,
        setMemberInfo,
        setMemberOptions,
        setIsExpired,
        checkoutObject,
        setCheckoutObject,
        setActiveScreen
    } = props;

    const [isFetching, setIsFetching] = useState(false);
    const [hasError, setHasError] = useState(false);

    // "memberId": "2443698",
    // "lastName": "Test"

    useEffect(() => {
        const urlParameters = new URLSearchParams(window.location.search);
        const id = urlParameters.get('id');
        const lastName = urlParameters.get('lastName');

        if (authenticationToken != null && id != null && lastName != null) {
            setMemberCredentials({'memberId': id, 'lastName': lastName});
            fetchMemberData(id, lastName);
        }
    }, [authenticationToken]);

    const fetchMemberData = async (id, ln) => {
        setIsExpired(false);
        setIsFetching(true);
        try {
            const response = await fetch(`https://${config.apiUrl}/api/membership/check`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": authenticationToken
                },
                body: JSON.stringify({
                    "memberId": id,
                    "lastName": ln
                })
            });
            if (!response.ok) {
                postLog(config, authenticationToken, response.url, String(response.status));
                throw new Error(response.url + ' ' + response.statusText);
            }
            const data = await response.json();
            console.log(data.data);
            if (data.data.primaryCardHolder != null) {
                setHasError(false);
                setIsMember(true);

                let country = data.data.address.country;
                if (country == 'United States' || country == 'United States of America' || country == 'USA') {
                    country = 'US';
                } else if (country == 'Canada') {
                    country = 'CA';
                }

                setCheckoutObject({
                    ...checkoutObject,
                    'billingFirstName': data.data.primaryCardHolder.firstName ?? '',
                    'billingLastName': data.data.primaryCardHolder.lastName ?? '',
                    'billingAddress1': data.data.address.streetAddress1 ?? '',
                    'billingCity': data.data.address.city ?? '',
                    'billingState': data.data.address.state ?? '',
                    'billingCountry': country ?? '',
                    'billingZipCode': data.data.address.zipCode ?? '',
                    'billingEmail': data.data.primaryCardHolder.email ?? '',
                    'billingPhoneNumber': data.data.primaryCardHolder.phoneNumber ?? '',
                    'manualEntryCardNumber': null,
                    'expDate': null,
                    'cvc': null
                });
                setMemberInfo(data.data);
                let now = new Date();
                let options = { timeZone: 'America/Los_Angeles' };
                let timeInSeattle = now.toLocaleString('en-US', options);
                if (new Date(timeInSeattle) > new Date(data.data.primaryCardHolder.membershipExpirationDate)) {
                    setIsExpired(true);
                }
                setActiveScreen("select");
                window.scrollTo(0, 200);
                fetchMemberOptions(data.data.primaryCardHolder.membershipId);
            } else {
                setHasError(true);
            }
        } catch (error) {
            console.error(error);
        }
        setIsFetching(false);
    };

    const fetchMemberOptions = async (membershipId) => {
        try {
            const response = await fetch(`https://${config.apiUrl}/api/membership/${membershipId}/eligible-upgrade-options`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": authenticationToken
                }
            });
            if (!response.ok) {
                postLog(config, authenticationToken, response.url, String(response.status));
                throw new Error(response.url + ' ' + response.statusText);
            }
            const data = await response.json();
            console.log(data.data);
            if (data.data) {
                setMemberOptions(data.data);
            } else {
                setHasError(true);
            }
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <>
            <h5>Reserve Member Tickets</h5>
            <label htmlFor="login-membership-number" className="sr-only">Membership Number</label>
            <input
                id="login-membership-number"
                className={`${hasError ? 'error' : ''} ${isMember ? 'success' : ''}`}
                type="text"
                placeholder="Membership Number"
                disabled={!authenticationToken}
                value={memberCredentials.memberId}
                onChange={(e) => setMemberCredentials(memberCredentials => ({...memberCredentials, memberId: e.target.value}))}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' && memberCredentials.memberId.length > 0 && memberCredentials.lastName.length > 0) {
                        fetchMemberData(memberCredentials.memberId, memberCredentials.lastName);
                    }
                }}
            />
            <label htmlFor="login-last-name" className="sr-only">Last Name</label>
            <input
                id="login-last-name"
                className={`${hasError ? 'error' : ''} ${isMember ? 'success' : ''}`}
                type="text"
                placeholder="Last Name"
                disabled={!authenticationToken}
                value={memberCredentials.lastName}
                onChange={(e) => setMemberCredentials(memberCredentials => ({...memberCredentials, lastName: e.target.value}))}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' && memberCredentials.memberId.length > 0 && memberCredentials.lastName.length > 0) {
                        fetchMemberData(memberCredentials.memberId, memberCredentials.lastName);
                    }
                }}
            />
            {hasError && <p>Member information not found.</p>}
            <button
                className="button"
                onClick={() => fetchMemberData(memberCredentials.memberId, memberCredentials.lastName)}
                disabled={memberCredentials.memberId.length < 1 || memberCredentials.lastName.length < 1 || isFetching}
            >
                {!isFetching ? 'Sign In' : <i className="fa fa-spinner fa-pulse"></i>}
            </button>
            <br/><p><a href="mailto:membership@seattleaquarium.org">Forgot Member Number?</a></p>
        </>
    )
}

export default TicketLogin;